import { forwardRef, Injectable } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => ChildContactInfoSubmitService),
  deps: [Router]
})
export abstract class ChildContactInfoSubmitter {
  public abstract submit(data: any, store: StoreService): void
  public abstract reset(store: StoreService): void
}

@Injectable({
  providedIn: 'root'
})
export class ChildContactInfoSubmitService implements ChildContactInfoSubmitter {
  constructor(
    public router: Router
  ) { }

  public submit(data: any, store: StoreService): void {
    store.patchChildInfo(data)
    this.router.navigate([store.basePath, 'parent-guardian-info'])
  }

  public reset(store: StoreService): void {
    this.router.navigate([store.basePath, 'child-info'])
  }
}
